import React from "react";
import Input from "../Components/FormComponents/Input"; 
import Dropdown from "../Components/FormComponents/Dropdown"; 

const FormController = (props) => {
  const { control, ...rest } = props;

  switch (control) {
    case "input":
      return <Input {...rest} />;
    case "dropdown":
      return <Dropdown {...rest} />;
    default:
      return null;
  }
};

export default FormController;